// CountBadge — the one unread indicator for list rows and tab icons.
//
// One signal, three tones:
//   ink    unread messages (inverse of the page, always high contrast)
//   accent mentions and direct messages, which need the reader
//   quiet  muted rooms, present but not asking for attention
// Counts above 99 read "99+". Nothing renders at zero. The text colour
// on the accent tone is fixed dark ink: white on the orange accent is
// only 2.6:1 in dark mode, dark ink is about 6.5:1 in both themes.

export type CountBadgeTone = "ink" | "accent" | "quiet";

const MAX_COUNT = 99;

export function formatBadgeCount(count: number): string {
  return count > MAX_COUNT ? `${MAX_COUNT}+` : String(count);
}

const TONE_CLASS: Record<CountBadgeTone, string> = {
  ink: "bg-foreground text-background",
  accent: "bg-primary text-[#0e1625]",
  quiet: "bg-foreground/[0.12] text-foreground/70",
};

export function CountBadge({
  count,
  tone,
  className = "",
}: {
  count: number;
  tone: CountBadgeTone;
  className?: string;
}) {
  if (count <= 0) return null;
  return (
    <span
      aria-hidden
      className={`inline-block min-w-4 shrink-0 rounded-full px-1 text-center text-[10px] font-medium leading-4 tabular-nums ${TONE_CLASS[tone]} ${className}`}
    >
      {formatBadgeCount(count)}
    </span>
  );
}
